import { onCLS, onINP, onLCP, onTTFB } from 'web-vitals';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

function sendToGTM({ name, value, id }: { name: string; value: number; id: string }) {
  if (!window.dataLayer) return;
  window.dataLayer.push({
    event: 'web_vitals',
    webVitalName: name,
    // CLS is unitless (0–1), others are in ms — normalize all to integers
    webVitalValue: Math.round(name === 'CLS' ? value * 1000 : value),
    webVitalId: id,
  });
}

export function reportWebVitals() {
  onCLS(sendToGTM);
  onINP(sendToGTM);
  onLCP(sendToGTM);
  onTTFB(sendToGTM);
}
